import { render, staticRenderFns } from "./EditClientBatchSendMaxCount.vue?vue&type=template&id=562b4cb2&scoped=true&"
import script from "./EditClientBatchSendMaxCount.vue?vue&type=script&lang=js&"
export * from "./EditClientBatchSendMaxCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562b4cb2",
  null
  
)

export default component.exports